<template>
    <m-input :active="focus" @click="setFocus()" :helper="helperText" :error="error">
        <input class="w-full outline-none p-2 bg-transparent rounded-md shadow-md" :placeholder="placeholder" v-bind="getAttrs()"
               v-model="model" :readonly="readonly" @focus="onFocus()" @blur="onBlur()"
               ref="input" @keydown.enter="$emit('enter')"
               :class="this.bottom ? 'border-b' : 'border'"/>
        <slot></slot>
    </m-input>
</template>
<script>

function formatValue(v) {
    if (!v)
        return 0;
    if (typeof v === "number")
        return v;

    if (typeof v === "string") {
        // replace , with .
        v = v.replace(',', '.')
        const f = parseFloat(v);
        if (Number.isNaN(f) || !Number.isFinite(f)) {
            return 0;
        }
        return f;
    }

    return 0;
}

export default {
    props: {
        name: String,
        autocomplete: {
            type: Boolean,
            default: false,
        },
        max: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: "text"
        },
        value: [String, Number],
        error: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        bottom: {
            type: Boolean,
            default: false
        },
        placeholder: String
    },
    data() {
        return {
            model: this.value,
            focus: false
        };
    },
    computed: {
        helperText() {
            if (this.max != 0) {
                return `${this.model.length}/${this.max} characters`;
            }
            return "";
        }
    },
    methods: {
        getAttrs() {
            var obj = {}
            if (this.name) {
                obj.name = this.name
            }
            // Only way now to disable autocompletion
            if (!this.autocomplete) {
                obj.autocomplete = 'new-password'
            }
            return obj
        },
        onFocus() {
            this.model = this.value;
            this.focus = true;
        },
        onBlur() {
            this.focus = false;
            console.log('Blur', this.model, formatValue(this.model));
            this.$emit('input', formatValue(this.model));
        },
        setFocus() {
            this.$refs.input.focus();
        }
    }
};
</script>
